import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/connected-products/audit/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.featureFlags[FeatureFlags.ConnectedProductsFrontend] &&
      context.userPermissions.hasAllowedPermission({
        path: PAGE_PATHS.CONNECTED_PRODUCTS,
        permission: Permission.UPDATE,
      });
    context.validatePermissions({ isAllowed, preload });
  },
});
